module.exports = __webpack_public_path__ + "img/car.8d9bd4ce.svg";